var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5L24.5 10.5M10.5 3.5L10.5 24.5M9.1 3.5H18.9C20.8602 3.5 21.8403 3.5 22.589 3.88148C23.2475 4.21703 23.783 4.75247 24.1185 5.41103C24.5 6.15972 24.5 7.13982 24.5 9.1V18.9C24.5 20.8602 24.5 21.8403 24.1185 22.589C23.783 23.2475 23.2475 23.783 22.589 24.1185C21.8403 24.5 20.8602 24.5 18.9 24.5H9.1C7.13982 24.5 6.15972 24.5 5.41103 24.1185C4.75247 23.783 4.21703 23.2475 3.88148 22.589C3.5 21.8403 3.5 20.8602 3.5 18.9V9.1C3.5 7.13982 3.5 6.15972 3.88148 5.41103C4.21703 4.75247 4.75247 4.21703 5.41103 3.88148C6.15972 3.5 7.13982 3.5 9.1 3.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/dataset.1613d5a45d993b26afdcdccd7bd7c25f.svg";
export { ForwardRef as ReactComponent };